import { useState, type FC } from 'react';

import { Trans, useTranslation } from '@mint-lib/i18n';

import { Chip, Truncation, Typography } from '@myn/mui';

type Props = {
  version: string;
  isClickable: boolean;
  onClick: () => void;
  disabled?: boolean;
};

const MediaPlanVersion: FC<Props> = ({
  version,
  isClickable,
  onClick,
  disabled,
}) => {
  const { t } = useTranslation('@myn/planning');
  const [isHovered, setIsHovered] = useState<boolean>(false);

  // hide letter "V" when there is no version
  const versionName = version.length !== 1 ? version : '';

  const handleMouseEnter = () => {
    if (!isClickable) {
      return;
    }
    setIsHovered(true);
  };

  const handleMouseLeave = () => {
    setIsHovered(false);
  };

  const handleClick = () => {
    if (!isClickable) {
      return;
    }
    onClick();
  };

  return (
    <Chip
      className="max-w-[300px]!"
      aria-label="Plan version"
      variant="filled"
      size="medium"
      color={isHovered ? 'secondary' : 'silver'}
      clickable={isClickable}
      disabled={disabled}
      label={
        <Truncation
          variant="caption02"
          fontSize="0.6875rem"
          fontWeight={400}
          tooltipTitle={versionName}
        >
          <Trans
            i18nKey="Version: <Bold>{{version}}</Bold>"
            t={t}
            components={{
              Bold: <Typography variant="caption01" />,
            }}
            values={{
              version: versionName,
            }}
          />
        </Truncation>
      }
      onClick={handleClick}
      onMouseEnter={handleMouseEnter}
      onMouseLeave={handleMouseLeave}
    />
  );
};

export default MediaPlanVersion;
